// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "9fa88889cbcceb6481ff62d101ae2959" + ".css";
};